export const googleCalendarUrlSE =
  "https://calendar.app.google/EUj2MdfYSnfZr1PUA";

export const googleCalendarUrlFI =
  "https://calendar.app.google/byKaHxfPaKxEtCdQ7";
